import { Paper, Typography, Button, TextField } from "@mui/material";

export default function HumanPiResolution({
  candidates,
  originaldata,
  proposedPi,
  setProposedPi,
  selectedPi,
  onSelect,
  onCreateRequest,
}) {
  console.log("pi", proposedPi);
  return (
    <Paper
      elevation={0}
      sx={{
        p: 2,
        border: "1px solid #e0e0e0",
        borderRadius: 2,
        backgroundColor: "#fafafa",
      }}
    >
      {candidates.map((candidate) => (
        <Paper
          key={candidate.id}
          sx={{
            p: 1.5,
            mb: 1,
            cursor: "pointer",
            border:
              selectedPi === candidate.id
                ? "2px solid #1976d2"
                : "1px solid #ddd",
          }}
          onClick={() => onSelect(candidate.id)}
        >
          <Typography fontWeight={600}>
            {candidate.name} {candidate.surname}
          </Typography>

          <Typography variant="body2">{candidate.email}</Typography>
        </Paper>
      ))}

      <Typography variant="subtitle2" sx={{ mt: 3 }}>
        Differentiate researcher
      </Typography>

      <TextField
        fullWidth
        sx={{ mt: 1 }}
        label=""
        helperText="Add institution or additional info.This will be appended to the surname"
        value={proposedPi?.suffix || ""}
        onChange={(e) =>
          setProposedPi({
            ...proposedPi,
            suffix: e.target.value,
          })
        }
      />
      {proposedPi?.suffix && (
        <Typography sx={{ mt: 1, fontStyle: "italic" }}>
          Preview: {proposedPi?.name || ""}
          {proposedPi?.familyname ? ` ${proposedPi.familyname}` : ""}
          {proposedPi?.suffix ? ` - ${proposedPi.suffix}` : ""}
        </Typography>
      )}
      <Button variant="outlined" sx={{ mt: 2 }} onClick={onCreateRequest}>
        Create differentiated PI
      </Button>
    </Paper>
  );
}
